const PushEvent = {
  mounted() {
    const phoenixHook = this;

    function pushEvent(e) {
      phoenixHook.pushEvent(e.detail.event, e.detail.payload)
    }

    this.el.addEventListener('push-event', pushEvent);
  },
}

export default PushEvent
